// Dependencies
import React, { Component } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from "react-share";

// Components & Containers
import "./style.css";

export default class componentName extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fundsAmount: props.fundsAmount,
      cerfiedUsersAmount: props.cerfiedUsersAmount,
      percentUser: 0,
      percentFunds: 0
    };
  }

  componentDidMount = () => {
    const { fundsAmount, cerfiedUsersAmount } = this.state;

    if (Object.keys(fundsAmount).length === 0)
      this.setState({ fundsAmount: { goal: 0, raised: 0 } });
    if (Object.keys(cerfiedUsersAmount).length === 0)
      this.setState({ cerfiedUsersAmount: { goal: 0, raised: 0 } });

    this.setState({
      percentUser: this.calculatePercent(cerfiedUsersAmount),
      percentFunds: this.calculatePercent(fundsAmount)
    });
  };

  calculatePercent = amount => (amount.raised * 100) / amount.goal;

  render() {
    const {
      percentFunds,
      percentUser,
      fundsAmount,
      cerfiedUsersAmount
    } = this.state;

    let priceFormat = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0
    });

    let numberFormat = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0
    });

    return (
      <section className="fundsRecipents">
        <h2 className="funds__title">{this.props.titleFundsAmount}</h2>
        {/* <div className="shareButtons">
          <FacebookShareButton
            title={this.props.facebookQuote}
            url="https://airdropvenezuela.org/"
            className="shareButtons__btn"
          >
            <span className="shareButtons__btn--facebook">
              {this.props.facebook}
            </span>
          </FacebookShareButton>
          <TwitterShareButton
            title={this.props.twitterQuote}
            url="https://airdropvenezuela.org/"
            className="shareButtons__btn"
          >
            <span className="shareButtons__btn--twitter">
              {this.props.twitter}
            </span>
          </TwitterShareButton>
          <WhatsappShareButton
            title={this.props.whatsappQuote}
            url="https://airdropvenezuela.org/"
            className="shareButtons__btn"
          >
            <span className="shareButtons__btn--whatsapp">
              {this.props.whatsapp}
            </span>
          </WhatsappShareButton>
        </div> */}
        <div className="funds__container">
          <div className="funds__container__left">
            <img src="/fundsLeft.png" alt="" />
          </div>
          <div className="funds__container__middle">
            <div className="funds__container__middle__outerBox">
              <div className="funds__container__middle__innerBox">
                <span className="textWithoutBubble">
                  {priceFormat.format(fundsAmount.raised)} USD{" "}
                  {this.props.bubbleRaised}
                </span>
                <div
                  className="funds__container__middle__innerBox__bar"
                  style={{ width: `${parseFloat(percentFunds).toFixed(2)}%` }}
                />
                <div className="containerBar">
                  <div
                    className="funds__container__middle__innerBox__bar--hidden"
                    style={{ width: `${parseFloat(percentFunds).toFixed(2)}%` }}
                  />
                  <div className="containerBar__bubble">
                    <img src="timeLine2.png" className="barTimeline" alt="" />
                    <div className="funds__container__middle__innerBox__bar__bubbleBox">
                      {priceFormat.format(fundsAmount.raised)} USD{" "}
                      {this.props.bubbleRaised}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="funds__container__right">
            <img src="/fundsRight.png" alt="" />
            <h3>
              {priceFormat.format(fundsAmount.goal)} USD <br />{" "}
              {this.props.bubbleGoal}
            </h3>
          </div>
        </div>
        <h2 className="recipents__title">
          {this.props.titleCertifiedFundsAmount}
        </h2>
        <div className="recipents__container">
          <div className="recipents__container__left">
            <img src="/recipentsLeft.png" alt="" />
          </div>
          <div className="recipents__container__middle">
            <div className="recipents__container__middle__outerBox">
              <div className="recipents__container__middle__innerBox">
                <span className="textWithoutBubble">
                  {numberFormat.format(cerfiedUsersAmount.raised)} Certified
                </span>
                <div
                  className="recipents__container__middle__innerBox__bar"
                  style={{ width: `${parseFloat(percentUser).toFixed(2)}%` }}
                />
                <div className="containerBar">
                  <div
                    className="recipents__container__middle__innerBox__bar--hidden"
                    style={{ width: `${parseFloat(percentUser).toFixed(2)}%` }}
                  />
                  <div className="containerBar__bubble">
                    <img src="timeLine2.png" className="barTimeline" alt="" />
                    <div className="recipents__container__middle__innerBox__bar__bubbleBox">
                      {" "}
                      {numberFormat.format(cerfiedUsersAmount.raised)}{" "}
                      {this.props.certified}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="recipents__container__right">
            <img src="/recipentsRight.png" alt="" />
            <h3>
              {numberFormat.format(cerfiedUsersAmount.goal)} {this.props.goal}
            </h3>
          </div>
        </div>
        <a
          target="_blank"
          href="https://www.airtm0.com/ivt/QVQtMTUzNjEwNTkzNjc3Mzc5NTU4My0zMzU0JCRBaXJkcm9wIFZlbmV6dWVsYSQkMSQkZW4="
          className="fundsRecipents__buttonBox"
        >
          {this.props.signup}
        </a>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FundsRaised/index.jsx